<template>
  <div id="preloader2" v-if="!pageLoaded">
    <div id="status2">
      <div class="spinner-chase">
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
        <div class="chase-dot"></div>
      </div>
    </div>
  </div>
  <div v-else>
    <!-- <Breadcrumb style="background-color: transparent" :items="items" /> -->

    <b-modal id="iconsModal" hide-footer hide-header size="lg" scrollable>
      <div
        class="d-flex align-items-center justify-content-end modal-title-head"
      >
        <div class="title-head">
          <p class="feedback-title-head">{{ $t('customFields.form.selectIcon')}}</p>
        </div>
        <svg
          @click="$bvModal.hide('iconsModal')"
          class="CloseFeedbackSettings"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
            fill="#F46A6A"
          />
        </svg>
      </div>
      <form class="search-bar">
        <button class="search-btn" type="button">
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.7467 15C14.0674 15 14.3884 14.8777 14.6329 14.6328C15.1224 14.1435 15.1224 13.3498 14.6329 12.8603L11.586 9.8135C13.2154 7.3595 12.9497 4.00983 10.7883 1.8485C8.32362 -0.616167 4.31323 -0.616167 1.84853 1.8485C-0.616175 4.31317 -0.616175 8.3235 1.84853 10.7883C3.08088 12.0207 4.69973 12.6368 6.31842 12.6368C7.53877 12.6368 8.75879 12.2863 9.81364 11.586L12.8605 14.6328C13.105 14.8777 13.4259 15 13.7467 15ZM3.40305 9.23367C1.79569 7.62633 1.79569 5.01083 3.40305 3.4035C4.20673 2.59983 5.26257 2.19783 6.31825 2.19783C7.37394 2.19783 8.42978 2.59967 9.23363 3.4035C10.841 5.01083 10.841 7.62633 9.23363 9.23367C7.62611 10.841 5.01057 10.841 3.40305 9.23367Z"
              fill="#787878"
            />
          </svg>
        </button>
        <input
          class="search-input"
          type="text"
          :placeholder="$t('common.grid.search')"
          name="search"
          v-model="searchQuery"
        />
      </form>
      <div class="d-flex flex-wrap modal-icons" style="gap: 54px">
        <div v-for="icon in filteredIcons" :key="icon" style="width: 24px">
          <i
            :class="[
              icon,
              'unique-icon',
              'fa-lg',
              { 'icon-selected': selectedIcon == icon },
            ]"
            @click="selectedIcon = icon"
          ></i>
        </div>
      </div>
      <div class="d-flex justify-content-end vp-mt-24 submit-con">
        <button
          type="button"
          class="btn btn-primary save-feedback"
          :disabled="!selectedIcon"
          @click="
            formChanged = true;
            customFields[selectedIndex].icon = selectedIcon;
            customFields[selectedIndex].fieldUpdated = true;
            $bvModal.hide('iconsModal');
          "
        >
          {{ $t('common.add').toUpperCase() }}
        </button>
      </div>
    </b-modal>

    <template v-if="!addFlow">
      <VpFormLayout>
        <template v-slot:content-header>
          <Breadcrumb style="background-color: transparent" :items="items" />
        </template>
        <template v-slot:content-body>
          <div>
            <div class="field-name-section">
              <div class="field-name-inputs">
                <div class="name-con">
                  <div class="d-flex align-items-center">
                    <vp-input
                      id="name"
                      width="416"
                      :class="{ 'vp-mb-32': sectionNameErr && sectionName }"
                      :label="$t('customFields.form.sectionName')"
                      maxlength="30"
                      v-model="sectionName"
                      :invalid="!!sectionNameErr && sectionName"
                      :errMsg="$t('customFields.form.sectionNameAlreadyExists')"
                      @input="findSectionName"
                    />
                  </div>
                  <div v-if="isMainSection" class="section-note">
                    <b>{{ $t("common.notes.note") }}:</b>
                    {{ $t("customFields.form.appliedToAll") }}
                  </div>
                </div>
                <div class="section-binded">
                  <p class="header-binded">
                    {{ $t("customFields.form.binding") }}
                  </p>
                  <v-radio-group
                    v-model="sectionBinding"
                    :disabled="!!$route.query.sectionId"
                  >
                    <v-radio
                      v-for="option in bindedOptions"
                      :key="option.value"
                      :label="option.text"
                      :value="option.value"
                    ></v-radio>
                  </v-radio-group>
                </div>

                <div
                  v-if="sectionBinding == 0 && !isMainSection"
                  class="user-type"
                >
                  <vp-treeselect
                    v-model="userTypes"
                    :label="$t('common.userType')"
                    :showPlaceholderIcon="true"
                    :options="userTypesOptions"
                    :isMultiple="true"
                    :width="'416'"
                    @input="formChanged = true"
                  />
                  <div v-if="notPermitted" class="selctions-note">
                    <b>{{ $t("common.notes.note") }}: </b
                    >{{ $t("customFields.form.notPermittedRemove") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="all-fields-add">
              <div
                class="all-fields-type-con"
                v-for="(field, index) in customFields"
                :key="index"
              >
                <div class="sections-remove-con">
                  <div class="sections-con d-flex justify-content-between">
                    <div class="left-section">
                      <div class="field-type">
                        <div
                          class="field-name-con"
                          :class="{ 'vp-mb-20': field.fieldNameErr }"
                        >
                          <div class="d-flex">
                            <vp-input
                              id="field-name"
                              v-model="field.name"
                              maxlength="30"
                              @input="
                                field.fieldUpdated = true;
                                validateFieldName(index);
                              "
                              width="416"
                              :label="$t('customFields.form.fieldName')"
                              :errMsg="
                                field.fieldNameErr
                                  ? $t(
                                      'customFields.form.fieldNameAlreadyExists'
                                    )
                                  : ''
                              "
                              :invalid="field.fieldNameErr"
                            />
                          </div>
                        </div>

                        <div class="field-type-con" style="margin-bottom: 16px">
                          <VpTreeselect
                            :showPlaceholderIcon="true"
                            width="416"
                            :showOptionsBorder="true"
                            v-model="field.type"
                            :options="fieldTypeOptions"
                            :isMultiple="false"
                            :label="$t('customFields.grid.fieldType')"
                            @select="
                              field.fieldUpdated = true;
                              fieldTypeChanged(index);
                            "
                          />
                        </div>

                        <template
                          v-if="
                            field.type === 'checkboxes' ||
                            field.type === 'radioButtons'
                          "
                        >
                          <div
                            v-for="(option, optionIndex) in field.options"
                            :key="optionIndex"
                            class="options-input-con d-flex align-items-center"
                            style="margin-bottom: 16px"
                          >
                            <vp-input
                              id="options"
                              width="416"
                              :class="{ 'vp-mb-20': option.err }"
                              :label="
                                $t('customFields.form.option') +
                                ' ' +
                                (+optionIndex + 1)
                              "
                              v-model.trim="option.name"
                              :errMsg="
                                option.err
                                  ? $t('customFields.form.optionAlreadyExists')
                                  : ''
                              "
                              :invalid="option.err"
                              maxlength="20"
                              @input="
                                field.fieldUpdated = true;
                                validateOption(index, optionIndex);
                              "
                            />
                            <svg
                              v-if="field.options.length > 2"
                              @click="
                                formChanged = true;
                                field.fieldUpdated = true;
                                field.options.splice(optionIndex, 1);
                              "
                              style="margin-inline-start: 16px"
                              width="23"
                              height="23"
                              viewBox="0 0 23 23"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.5 0C5.13667 0 0 5.13667 0 11.5C0 17.8633 5.13667 23 11.5 23C17.8633 23 23 17.8633 23 11.5C23 5.13667 17.8633 0 11.5 0ZM17.3522 15.3844C17.8889 15.9211 17.8889 16.79 17.3522 17.3267C17.0711 17.6078 16.7389 17.7356 16.3811 17.7356C16.0233 17.7356 15.6656 17.6078 15.41 17.3267L11.5767 13.4933L7.71778 17.3267C7.43667 17.6078 7.10444 17.7356 6.74667 17.7356C6.38889 17.7356 6.03111 17.6078 5.77556 17.3267C5.23889 16.79 5.23889 15.9211 5.77556 15.3844L9.63445 11.5256L5.77556 7.69222C5.23889 7.15556 5.23889 6.28667 5.77556 5.75C6.31222 5.21333 7.18111 5.21333 7.71778 5.75L11.5767 9.60889L15.4356 5.75C15.9722 5.21333 16.8411 5.21333 17.3778 5.75C17.9144 6.28667 17.9144 7.15556 17.3778 7.69222L13.5189 11.5511L17.3522 15.3844Z"
                                fill="#F46A6A"
                              />
                            </svg>
                          </div>
                        </template>

                        <div
                          class="rating-con"
                          v-if="field.type === 'ratingScale'"
                        >
                          <div class="show-as-msg">
                            <p class="show-as">
                              {{ $t("customFields.form.showAs") }}
                            </p>
                          </div>
                          <v-radio-group
                            @change="
                              formChanged = true;
                              field.fieldUpdated = true;
                              field.showAs == 'smileys'
                                ? (field.scaleCount = 3)
                                : (field.scaleCount = 5);
                            "
                            v-model="field.showAs"
                          >
                            <v-radio
                              v-for="option in scaleOptions"
                              :key="option.value"
                              :label="option.text"
                              :value="option.value"
                            ></v-radio>
                          </v-radio-group>

                          <v-radio-group
                            v-if="field.showAs == 'stars'"
                            style="margin-top: 24px !important"
                            @change="
                              formChanged = true;
                              field.fieldUpdated = true;
                            "
                            v-model="field.scaleCount"
                          >
                            <v-radio
                              v-for="option in starsScaleOptions"
                              :key="option.value"
                              :label="option.text"
                              :value="option.value"
                            ></v-radio>
                          </v-radio-group>

                          <v-radio-group
                            v-else-if="field.showAs == 'smileys'"
                            style="margin-top: 24px !important"
                            @change="
                              formChanged = true;
                              field.fieldUpdated = true;
                            "
                            v-model="field.scaleCount"
                          >
                            <v-radio
                              v-for="option in smileysScaleOptions"
                              :key="option.value"
                              :label="option.text"
                              :value="option.value"
                            ></v-radio>
                          </v-radio-group>

                          <div>
                            <div
                              style="margin-top: 24px"
                              class="d-flex align-items-center"
                            >
                              <template v-if="field.showAs === 'labels'">
                                <span
                                  class="label-label d-flex align-items-center justify-content-center"
                                  v-for="scaleIndex in field.scaleCount"
                                  :key="scaleIndex"
                                  >{{ scaleIndex }}</span
                                >
                              </template>

                              <template v-else-if="field.showAs === 'stars'">
                                <div
                                  class="d-flex"
                                  style="margin-inline-end: 8px"
                                  v-for="starIndex in field.scaleCount"
                                  :key="starIndex"
                                >
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M15.3617 24.7895C15.1365 24.6655 14.8635 24.6655 14.6383 24.7895L6.63244 29.1971C6.63237 29.1971 6.6323 29.1971 6.63223 29.1972C6.48701 29.2767 6.34018 29.2582 6.21688 29.1648C6.09075 29.0692 6.00489 28.9022 6.03931 28.6907C6.03931 28.6907 6.03932 28.6907 6.03932 28.6906L7.57059 19.3534C7.60924 19.1178 7.53338 18.8779 7.36632 18.7073L0.890697 12.0949L0.889112 12.0933C0.756863 11.9591 0.718807 11.7708 0.774427 11.5911C0.829692 11.4125 0.95551 11.3044 1.10996 11.2812L1.11156 11.281L10.0624 9.91808C10.3093 9.88048 10.5213 9.72243 10.6279 9.49651L14.6345 0.999694L14.6352 0.998264C14.7883 0.671773 15.2101 0.661801 15.3724 1.00103C15.3726 1.00139 15.3727 1.00174 15.3729 1.00209L19.372 9.4961C19.4784 9.72223 19.6905 9.88046 19.9376 9.91808L28.8884 11.281L28.89 11.2812C29.0445 11.3044 29.1703 11.4125 29.2256 11.5911C29.2812 11.7708 29.2431 11.9591 29.1109 12.0933L29.1093 12.0949L22.6337 18.7073C22.4666 18.8779 22.3908 19.1178 22.4294 19.3534L23.9607 28.6906C23.9953 28.9027 23.9088 29.0717 23.7822 29.1679C23.6594 29.2613 23.5151 29.279 23.3714 29.1992L23.3687 29.1977L15.3617 24.7895Z"
                                      stroke="#787878"
                                      stroke-width="1.5"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                              </template>

                              <template v-else-if="field.showAs === 'smileys'">
                                <div
                                  class="d-flex"
                                  style="margin-inline-end: 8px"
                                  v-for="(
                                    smiley, smileyIndex
                                  ) in getVisibleSmileys(field.scaleCount)"
                                  :key="smileyIndex"
                                >
                                  <div
                                    class="d-flex align-items-center"
                                    style="flex-direction: column"
                                  >
                                    <span v-html="getSmileySvg(smiley)"></span>
                                    <p class="smiley-text">
                                      {{
                                        setSmileysText(field.scaleCount)[
                                          smileyIndex
                                        ]
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </template>

                              <button
                                v-if="field.showAs === 'labels'"
                                class="enabled-remove-icon"
                                :class="{
                                  'closed-icon': field.scaleCount <= 2,
                                }"
                              >
                                <svg
                                  style="margin-inline-start: 8px"
                                  @click="
                                    field.fieldUpdated = true;
                                    removeOption(index);
                                  "
                                  :disabled="field.scaleCount <= 2"
                                  width="23"
                                  height="23"
                                  viewBox="0 0 23 23"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M11.5 0C5.13667 0 0 5.13667 0 11.5C0 17.8633 5.13667 23 11.5 23C17.8633 23 23 17.8633 23 11.5C23 5.13667 17.8633 0 11.5 0ZM17.3522 15.3844C17.8889 15.9211 17.8889 16.79 17.3522 17.3267C17.0711 17.6078 16.7389 17.7356 16.3811 17.7356C16.0233 17.7356 15.6656 17.6078 15.41 17.3267L11.5767 13.4933L7.71778 17.3267C7.43667 17.6078 7.10444 17.7356 6.74667 17.7356C6.38889 17.7356 6.03111 17.6078 5.77556 17.3267C5.23889 16.79 5.23889 15.9211 5.77556 15.3844L9.63445 11.5256L5.77556 7.69222C5.23889 7.15556 5.23889 6.28667 5.77556 5.75C6.31222 5.21333 7.18111 5.21333 7.71778 5.75L11.5767 9.60889L15.4356 5.75C15.9722 5.21333 16.8411 5.21333 17.3778 5.75C17.9144 6.28667 17.9144 7.15556 17.3778 7.69222L13.5189 11.5511L17.3522 15.3844Z"
                                    fill="#F46A6A"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>

                        <button
                          type="button"
                          v-if="
                            field.type &&
                            (field.type === 'checkboxes' ||
                              field.type === 'radioButtons' ||
                              (field.type === 'ratingScale' &&
                                field.showAs === 'labels'))
                          "
                          class="add-circle"
                          @click="
                            field.fieldUpdated = true;
                            addOption(index);
                          "
                          :disabled="
                            (field.type === 'ratingScale' &&
                              field.scaleCount >= 10) ||
                            ((field.type === 'checkboxes' ||
                              field.type === 'radioButtons') &&
                              field.options.some((opt) => !opt.name || opt.err))
                          "
                          style="margin-top: 16px"
                        >
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.097 9.25605C15.8297 9.51843 15.4715 9.66776 15.097 9.67305H9.675V15.0951C9.67342 15.4706 9.52352 15.8304 9.25793 16.096C8.99235 16.3616 8.63259 16.5115 8.257 16.5131C8.07034 16.5147 7.88523 16.4791 7.71247 16.4084C7.5397 16.3377 7.38275 16.2333 7.25076 16.1013C7.11876 15.9693 7.01437 15.8123 6.94368 15.6396C6.87299 15.4668 6.8374 15.2817 6.839 15.0951V9.67505H1.418C1.23179 9.67505 1.04739 9.63837 0.875355 9.56711C0.703315 9.49585 0.546997 9.3914 0.415323 9.25973C0.28365 9.12805 0.1792 8.97174 0.107939 8.7997C0.0366776 8.62766 0 8.44327 0 8.25705C0 8.07084 0.0366776 7.88645 0.107939 7.71441C0.1792 7.54237 0.28365 7.38605 0.415323 7.25437C0.546997 7.1227 0.703315 7.01825 0.875355 6.94699C1.04739 6.87573 1.23179 6.83905 1.418 6.83905H6.84V1.41805C6.8384 1.23139 6.87398 1.04628 6.94468 0.873519C7.01537 0.700757 7.11976 0.543802 7.25176 0.411808C7.38375 0.279815 7.54071 0.175426 7.71347 0.104732C7.88623 0.0340372 8.07134 -0.00154838 8.258 5.16557e-05C8.44466 -0.00154838 8.62977 0.0340372 8.80253 0.104732C8.97529 0.175426 9.13225 0.279815 9.26424 0.411808C9.39624 0.543802 9.50063 0.700757 9.57132 0.873519C9.64202 1.04628 9.6776 1.23139 9.676 1.41805V6.84005H15.098C15.2847 6.83845 15.4698 6.87404 15.6425 6.94473C15.8153 7.01543 15.9723 7.11981 16.1042 7.25181C16.2362 7.3838 16.3406 7.54076 16.4113 7.71352C16.482 7.88628 16.5176 8.07139 16.516 8.25805C16.4914 8.62881 16.3444 8.98091 16.098 9.25905L16.097 9.25605Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <template v-if="field.type">
                      <div class="right-section">
                        <div class="sep-items-line"></div>
                        <div
                          v-if="field.type !== 'toggleButton'"
                          class="align-items-center d-flex mandatory"
                        >
                          <p class="mandatory">{{ $t("common.mandatory") }}</p>
                          <b-form-checkbox
                            switch
                            size="lg"
                            v-model="field.isMandatory"
                            @change="
                              formChanged = true;
                              field.fieldUpdated = true;
                            "
                            class="switch-gray radio-updateArea"
                          ></b-form-checkbox>
                        </div>
                        <div class="align-items-center d-flex filled-by">
                          <p class="filled-by">
                            {{ $t("customFields.grid.fillableByUser") }}
                          </p>
                          <b-form-checkbox
                            switch
                            size="lg"
                            v-model="field.isFillableByUser"
                            @change="
                              formChanged = true;
                              field.fieldUpdated = true;
                            "
                            class="switch-gray radio-updateArea"
                          ></b-form-checkbox>
                        </div>
                        <template
                          v-if="
                            field.type !== 'checkboxes' &&
                            field.type !== 'longText'
                          "
                        >
                          <div class="align-items-center d-flex padge">
                            <p class="padge">
                              {{ $t("customFields.form.badgeAllowed") }}
                            </p>
                            <b-form-checkbox
                              switch
                              size="lg"
                              v-model="field.isAllowedPrint"
                              class="switch-gray radio-updateArea"
                              @change="
                                formChanged = true;
                                field.fieldUpdated = true;
                                field.icon = '';
                              "
                            ></b-form-checkbox>
                          </div>
                          <div
                            v-if="field.isAllowedPrint"
                            class="parking-icon-con d-flex"
                          >
                            <div v-if="!field.icon" class="input-icon">
                              <div class="emty-input">
                                {{ $t("customFields.form.icon") }}
                              </div>
                            </div>
                            <div v-else class="parking-input-icon d-flex">
                              <div class="second-input-con">
                                <div class="second-input-title">
                                  {{ $t("customFields.form.icon") }}
                                </div>
                                <div class="second-input-text text-capitalize">
                                  {{ getIconName(field.icon) }}
                                </div>
                              </div>
                              <div class="parking-con">
                                <i
                                  style="color: #103f5e"
                                  class="fa-lg"
                                  :class="field.icon"
                                ></i>
                              </div>
                            </div>
                            <button
                              class="select-btn"
                              @click="
                                selectedIndex = index;
                                selectedIcon = field.icon;
                                searchQuery = '';
                                $bvModal.show('iconsModal');
                              "
                              type="button"
                            >
                              {{ $t("common.select") }}
                            </button>
                          </div>
                        </template>

                        <div class="show-on-con">
                          <div class="show-as-msg">
                            <p class="show-as">
                              {{ $t("customFields.grid.showOn") }}
                            </p>
                          </div>

                          <div class="radios-container d-flex">
                            <v-radio-group
                              v-model="field.showOn"
                              @change="
                                if (field.showOn === 'sign_out')
                                  field.isPreRegFilled = false;
                                field.fieldUpdated = true;
                                formChanged = true;
                              "
                            >
                              <v-radio
                                v-for="option in showOnOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </div>

                        <label
                          class="d-flex prereg-check customized-checkbox"
                          :class="{
                            'show-item':
                              field.showOn === 'check_in' ||
                              field.showOn === 'sign_in',
                          }"
                        >
                          <b-form-checkbox
                            class="custom-checkbox-dark custom-checkbox"
                            v-model="field.isPreRegFilled"
                            @change="
                              formChanged = true;
                              field.fieldUpdated = true;
                            "
                          >
                          </b-form-checkbox>
                          <p
                            class="text"
                            style="margin-top: 24px; margin-bottom: unset"
                          >
                            {{ $t("customFields.form.preRegFilled") }}
                          </p>
                        </label>
                      </div>
                    </template>
                  </div>
                  <div class="remove-section">
                    <svg
                      @click="deleteCustomField(index)"
                      v-if="
                        customFields.length > 1 ||
                        (isMainSection && field.name && field.type)
                      "
                      width="20"
                      height="28"
                      viewBox="0 0 20 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19 3H14V2C14 0.9 13.1 0 12 0H8C6.9 0 6 0.9 6 2V3H1C0.4 3 0 3.4 0 4C0 4.6 0.4 5 1 5H7H13H19C19.6 5 20 4.6 20 4C20 3.4 19.6 3 19 3ZM8 3V2H12V3H8Z"
                        fill="#F46A6A"
                      />
                      <path
                        d="M19.7 6.3C19.6 6.1 19.3 6 19 6H1C0.7 6 0.4 6.1 0.3 6.3C0.1 6.5 0 6.8 0 7.1L1.8 25.3C2 26.8 3.3 28 4.8 28H15.2C16.7 28 18 26.9 18.2 25.3L20 7.1C20 6.8 19.9 6.5 19.7 6.3ZM6.1 24C5.5 24 5.1 23.6 5 23.1L4 11.1C4 10.5 4.4 10.1 4.9 10C5.5 9.9 5.9 10.4 6 10.9L7 22.9C7 23.5 6.6 24 6.1 24ZM11 23C11 23.6 10.6 24 10 24C9.4 24 9 23.6 9 23V11C9 10.4 9.4 10 10 10C10.6 10 11 10.4 11 11V23ZM15 23.1C15 23.6 14.5 24 14 24H13.9C13.3 24 12.9 23.5 13 22.9L14 10.9C14 10.3 14.5 9.9 15.1 10C15.7 10 16.1 10.5 16 11.1L15 23.1Z"
                        fill="#F46A6A"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  v-if="index !== customFields.length - 1"
                  class="bottom-border"
                ></div>
              </div>
              <div class="add-field-con">
                <button
                  class="add-field-btn"
                  @click="
                    formChanged = true;
                    addCustomField();
                  "
                  :disabled="!isCustomFieldsValid"
                >
                  {{ $t("customFields.form.addField") }}
                </button>
              </div>

              <div ref="bottomEl" id="bottomEl"></div>
            </div>
          </div>
        </template>

        <template v-slot:content-footer>
          <VpButton
            v-if="sectionBinding == 0 || !!$route.query.sectionId"
            :text="
              !!$route.query.sectionId ? $t('common.edit') : $t('common.add')
            "
            :disabled="
              !isFormValid ||
              !!sectionNameErr ||
              isLoading ||
              (!!$route.query.sectionId && !formChanged)
            "
            :isLoading="isLoading"
            :height="'37px'"
            :width="'151px'"
            @click="onSubmit()"
          />

          <template v-else>
            <VpButton
              :text="$t('customFields.form.proceed')"
              :disabled="!isFormValid || !!sectionNameErr || isLoading"
              :height="'37px'"
              :width="'308px'"
              @click="addFlow = true"
            />

            <VpButton
              :text="$t('customFields.form.skip')"
              :disabled="!isFormValid || !!sectionNameErr || isLoading"
              :isLoading="isLoading"
              :height="'37px'"
              :width="'151px'"
              @click="onSubmit()"
            />
          </template>
        </template>
      </VpFormLayout>
    </template>

    <template v-else>
      <VpFormLayout>
        <template v-slot:content-header>
          <Breadcrumb style="background-color: transparent" :items="items" />
        </template>
        <template v-slot:content-body>
          <div class="all-con">
            <div class="all-section-applied">
              <div class="section-applied-on">
                <p class="applied-text">
                  {{ $t("customFields.form.sectionAppliedOn") }}
                </p>
                <div class="sites-flows-con d-flex">
                  <div class="flows">
                    <div class="site-dropdown error-dropdown">
                      <VpTreeselect
                        zIndex="100"
                        :showPlaceholderIcon="true"
                        width="416"
                        :showOptionsBorder="true"
                        :showNoResults="true"
                        :options="sitesOptions"
                        :allowEmpty="true"
                        :show-labels="true"
                        :isMultiple="true"
                        :label="$t('common.site')"
                        v-model="sites"
                        :errMsg="
                          showErrorMessage
                            ? 'No user types available to add this section to their flows.'
                            : ''
                        "
                        noResultMessage="No results found"
                      />
                    </div>
                    <div class="flow-dropdown">
                      <VpTreeselect
                        zIndex="100"
                        :showPlaceholderIcon="true"
                        width="416"
                        :showOptionsBorder="true"
                        :showNoResults="true"
                        :options="flowsOptions"
                        :allowEmpty="true"
                        :show-labels="true"
                        :isMultiple="true"
                        :flat="true"
                        :autoDeselectDescendants="true"
                        :autoSelectDescendants="true"
                        :label="$t('journeyBuilder.grid.flow')"
                        v-model="flows"
                        :disabled="!sites.length || !flowsOptions.length"
                        noResultMessage="No results found"
                      />
                    </div>
                  </div>
                  <div
                    style="background: #ffffff"
                    class="journey-height"
                    v-if="sites.length > 0 && flows.length > 0"
                  >
                    <div class="journey">
                      <div class="journey-con d-flex">
                        <carousel :per-page="slidesPerView" :mouse-drag="true">
                          <slide
                            class="swiper-button-slide"
                            v-for="flow in visibleFlows"
                            :key="flow"
                          >
                            <button
                              v-if="getFlow(flow)"
                              class="swiper-button"
                              :class="{
                                'active-btn': flow === activeFlow,
                                'notSelected-btn': flow !== activeFlow,
                              }"
                              :disabled="false"
                              @click="handleActiveFlow(flow)"
                            >
                              <p class="custom-btn">{{ getFlow(flow).name }}</p>
                            </button>
                          </slide>
                        </carousel>
                      </div>

                      <div id="white-con">
                        <div class="white-box">
                          <div class="journey-one">
                            <p class="journey-title">
                              {{ $t("journeyBuilder.grid.journey") }}
                            </p>
                            <div
                              style="margin-bottom: 0px"
                              class="journey-name"
                            >
                              <div class="box-text-one">
                                {{ activeFlowJourney.name }}
                              </div>
                            </div>
                          </div>
                          <div
                            style="
                              height: 1px;
                              background: #ebebeb;
                              margin-top: 16px;
                              margin-bottom: 16px;
                            "
                            class="grey-l"
                          ></div>
                          <div class="user-type">
                            <p class="user-type-title">
                              {{ $t("common.userType") }}
                            </p>
                            <div class="user-type-con d-flex flex-wrap">
                              <div class="user-type-con d-flex flex-wrap">
                                <div
                                  class="box-one"
                                  v-for="(
                                    userType, index
                                  ) in activeFlowUserTypes"
                                  :key="index"
                                >
                                  <div class="box-text">
                                    {{ userType.name }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style="
                              height: 1px;
                              background: #ebebeb;
                              margin-top: 16px;
                              margin-bottom: 16px;
                            "
                            class="grey-l"
                          ></div>
                          <div class="section-two">
                            <p class="section-title">
                              {{ $t("customFields.form.section") }}
                            </p>
                            <div class="section-details">
                              <p
                                v-if="activeFlowSections?.length === 0"
                                class="no-assigned-sections"
                              >
                                {{ $t("customFields.form.noAssignedSections") }}
                              </p>
                              <div
                                v-else
                                class="user-type-con d-flex flex-wrap"
                              >
                                <!-- Render sections here -->
                                <div
                                  class="box-one"
                                  v-for="(section, index) in activeFlowSections"
                                  :key="index"
                                >
                                  <div class="box-text">{{ section.name }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="height: 100px" class="space"></div>
            </div>
          </div>
        </template>

        <template v-slot:content-footer>
          <button @click="addFlow = false" class="out-back-btn">
            <svg
              width="37"
              height="37"
              viewBox="0 0 37 37"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              :style="{ transform: getLanguage === 'ar' ? 'scaleX(-1)' : '' }"
            >
              <path
                d="M16.9258 23.6953H6.77193"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M10.1562 28.2031L6.77163 23.7864L10.1562 19.1775"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle cx="18.5" cy="18.5" r="18.5" fill="#103F5E" />
              <path
                d="M27.563 17.4131H13.8327L20.1394 11.1064L18.5374 9.51562L9.51172 18.5413L18.5374 27.5669L20.1281 25.9761L13.8327 19.6695H27.563V17.4131Z"
                fill="white"
              />
            </svg>
          </button>

          <VpButton
            :text="$t('customFields.form.skip')"
            :disabled="!!sectionNameErr || isLoading"
            :isLoading="isLoading && isSkipAndAdd"
            :height="'37px'"
            :width="'151px'"
            @click="
              isSkipAndAdd = true;
              isAdd = false;
              onSubmit();
            "
          />

          <VpButton
            :text="$t('common.add')"
            :disabled="!flows.length || !!sectionNameErr || isLoading"
            :isLoading="isLoading && isAdd"
            :height="'37px'"
            :width="'151px'"
            @click="
              isSkipAndAdd = false;
              isAdd = true;
              onSubmit();
            "
          />
        </template>
      </VpFormLayout>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { debounce } from "lodash";
import { Carousel, Slide } from "vue-carousel";

import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import userTypesService from "@/services/userType";
import smileysJson from "./smileys.json";
import iconList from "./fontAwesomeIcons.json";
import sitesService from "@/services/sites";

export default {
  components: {
    Breadcrumb,
    Carousel,
    Slide,
  },
  data() {
    return {
      slidesPerView: 1,
      selectedIndex: null,
      selectedIcon: "",
      sitesOptions: [],
      flowsOptions: [],
      sites: [],
      selectedFlows: [],
      activeFlowJourney: "",
      activeFlowUserTypes: [],
      activeFlowSections: [],
      activeFlow: null,
      journey: [],
      flows: [],
      visibleFlows: [],
      userTypes: [],
      addFlow: false,
      searchQuery: "",
      flowsLoaded: false,
      items: [
        {
          text: this.$t("sideNavbarMenu.settings.list.customFields"),
          to: { name: "customFieldsList" },
        },
        {
          text: `${
            this.$route.query.sectionId
              ? this.$t("common.edit")
              : this.$t("common.add")
          } ${this.$t("customFields.form.section")}`,
          active: true,
        },
      ],
      pageLoaded: false,
      isInitializing: true,
      isLoading: false,
      isSkipAndAdd: false,
      isAdd: false,
      isMainSection: false,
      notPermitted: false,
      sectionName: "",
      sectionNameErr: "",
      formChanged: false,
      sectionBinding: 0,
      userTypesOptions: [],
      userType: [],
      deletedCustomFields: [],
      customFields: [
        {
          id: null,
          fieldUpdated: false,
          name: "",
          type: null,
          options: [
            { name: "", err: false },
            { name: "", err: false },
          ],
          showAs: "labels",
          scaleCount: 5,
          icon: "",
          isMandatory: true,
          isFillableByUser: true,
          isPreRegFilled: false,
          isAllowedPrint: false,
          showOn: null,
        },
      ],
      icons: iconList,
      fieldTypeOptions: [
        { id: "checkboxes", label: this.$t("customFields.form.checkboxes") },
        {
          id: "radioButtons",
          label: this.$t("customFields.form.radioButtons"),
        },
        { id: "text", label: this.$t("customFields.form.text") },
        { id: "number", label: this.$t("customFields.form.number") },
        { id: "date", label: this.$t("customFields.form.date") },
        { id: "longText", label: this.$t("customFields.form.longText") },
        { id: "ratingScale", label: this.$t("customFields.form.ratingScale") },
        {
          id: "toggleButton",
          label: this.$t("customFields.form.toggleButton"),
        },
      ],
      scaleOptions: [
        { value: "labels", text: this.$t("customFields.form.labels") },
        { value: "stars", text: this.$t("customFields.form.stars") },
        { value: "smileys", text: this.$t("customFields.form.smileys") },
      ],
      starsScaleOptions: [
        { value: 5, text: `5 ${this.$t("customFields.form.stars")}` },
        { value: 7, text: `7 ${this.$t("customFields.form.stars")}` },
      ],
      smileysScaleOptions: [
        { value: 3, text: `3 ${this.$t("customFields.form.smileys")}` },
        { value: 5, text: `5 ${this.$t("customFields.form.smileys")}` },
      ],
      bindedOptions: [
        { value: 0, text: this.$t("complianceList.form.userProfile") },
        { value: 1, text: this.$t("common.visit") },
      ],
      showOnOptions: [
        { value: "check_in", text: this.$t("common.checkIn") },
        { value: "sign_in", text: this.$t("common.signIn") },
        { value: "sign_out", text: this.$t("common.signOut") },
      ],
    };
  },
  async beforeMount() {
    // document.getElementById("preloader").style.display = "block";
    // document.getElementById("status").style.display = "block";
    const { data } = await userTypesService.getPermittedUserTypes();
    this.userTypesOptions = data;

    sitesService.getSitesWithAreasAndKiosks().then((data) => {
      this.sitesOptions = data.data.map((site) => {
        return {
          id: site.id,
          label: site.name,
          name: site.name,
          parent_areas: site.parent_areas,
        };
      });
      this.sitesOptions = this.sitesOptions.filter(
        (item) => !!item.parent_areas.length
      );
    });

    if (this.$route.query.sectionId) {
      this.getSection(this.$route.query.sectionId).then((data) => {
        console.log("getsection", data);
        this.isMainSection = data.isMainSection;
        this.notPermitted = !!data.user_types.find((item) => !item.isPermitted);
        this.sectionName = data.name;
        this.sectionBinding = data.type;
        this.userTypes = data.user_types.map((item) => {
          return item.id;
        });
        if (this.notPermitted) {
          data.user_types.map((item) => {
            if (!item.isPermitted) {
              this.userTypesOptions.push({
                id: item.id,
                label: item.name,
                isDisabled: true,
              });
            }
          });
        }
        const customFields = data.custom_fields.map((item) => {
          const obj = {
            id: item.id,
            fieldUpdated: false,
            name: item.name,
            type: item.type,
            isMandatory: item.is_mandatory == 1,
            isFillableByUser: item.is_fillable_by_user == 1,
            isPreRegFilled: item.is_pre_registration_filled == 1,
            isAllowedPrint: item.is_allowed_print == 1,
            icon: item.is_allowed_print ? item.icon : "",
            showOn: item.show_type,
            options: [
              { name: "", err: false },
              { name: "", err: false },
            ],
            showAs: "labels",
            scaleCount: 5,
          };
          if (item.type == "checkboxes" || item.type == "radioButtons") {
            obj.options = item.metadata[0].options.map((option) => {
              return {
                name: option,
              };
            });
          } else if (item.type == "ratingScale") {
            obj.showAs = item.metadata[0].show_as;
            obj.scaleCount = item.metadata[0].scale_count;
          }
          return obj;
        });
        this.customFields = customFields;
        this.pageLoaded = true;
        setTimeout(() => {
          this.isInitializing = false;
        }, 2000);
      });
    } else {
      this.pageLoaded = true;
      this.isInitializing = false;
      // setTimeout(() => {
      //   document.getElementById("preloader").style.display = "none";
      //   document.getElementById("status").style.display = "none";
      // }, 1000);
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
    this.findSectionName = debounce(this.checkSectionName.bind(this), 500);

    document.addEventListener("click", this.handleClickOutside);
  },
  computed: {
    ...mapGetters("authfack", ["userDetails"]),
    ...mapGetters("i18N", ["getLanguage"]),

    showErrorMessage() {
      return (
        this.flows.length === 0 &&
        this.sites.length > 0 &&
        this.flowsOptions.length === 0 &&
        this.flowsLoaded
      );
    },

    isFormValid() {
      const allFieldsEmpty = this.customFields.some(
        (field) => !field.name && !field.type
      );
      if (
        !this.isMainSection &&
        this.customFields?.length === 1 &&
        allFieldsEmpty
      )
        return false;
      else if (
        this.isMainSection &&
        this.customFields?.length === 1 &&
        allFieldsEmpty
      )
        return true;

      // Check if any field has fieldNameErr set to true
      const hasFieldNameError = this.customFields.some(
        (field) => field.fieldNameErr
      );

      // Check if any required field is empty or null
      const hasEmptyRequiredFields = this.customFields.some(
        (field) =>
          !field.name ||
          !field.type ||
          ((field.type === "checkboxes" || field.type === "radioButtons") &&
            (field.options.filter((option) => !!option.name).length < 2 ||
              field.options.some((option) => option.err))) ||
          !field.showOn
          || (field.isAllowedPrint && !field.icon)
      );

      // Check if any option has err set to true
      const hasOptionError = this.customFields.some((field) =>
        field.options.some((option) => option.err)
      );

      // Return true if all conditions are met
      const fieldsRequiredValid =
        !hasFieldNameError && !hasEmptyRequiredFields && !hasOptionError;
      const fieldsValid = allFieldsEmpty || fieldsRequiredValid;
      const userTypesValid =
        (this.sectionBinding == 0 && this.userTypes?.length) ||
        this.sectionBinding == 1;
      return fieldsValid && this.sectionName && userTypesValid;
    },
    isCustomFieldsValid() {
      // Check if any field has fieldNameErr set to true
      const hasFieldNameError = this.customFields.some(
        (field) => field.fieldNameErr
      );

      // Check if any required field is empty or null
      const hasEmptyRequiredFields = this.customFields.some(
        (field) =>
          !field.name ||
          !field.type ||
          ((field.type === "checkboxes" || field.type === "radioButtons") &&
            field.options.some((option) => !option.name || option.err)) ||
          !field.showOn
          || (field.isAllowedPrint && !field.icon)
      );

      // Check if any option has err set to true
      const hasOptionError = this.customFields.some((field) =>
        field.options.some((option) => option.err)
      );

      // Return true if all conditions are met
      return !hasFieldNameError && !hasEmptyRequiredFields && !hasOptionError;
    },
    filteredIcons() {
      return this.icons.filter((icon) =>
        icon.includes(this.searchQuery.toLowerCase())
      );
    },
  },
  watch: {
    pageLoaded(val) {
      let emptySectionAdded = false;
      if (this.isMainSection && this.customFields.length == 0) {
        this.addCustomField();
        emptySectionAdded = true;
      }
      if (val && this.$route.query.scroll && !emptySectionAdded) {
        this.addCustomField();
        setTimeout(() => {
          this.$refs.bottomEl?.scrollIntoView();
        }, 500);
      }
    },
    sites(newValue, oldValue) {
      this.changeValues();
      if (newValue !== oldValue) {
        this.flows = []; // Reset flows
        this.visibleFlows = [];
        this.selectedFlows = []; // Reset flow details
        this.activeFlow = null;
        this.activeFlowUserTypes = [];
      }
    },
    flows(newFlows, oldFlows) {
      if (newFlows !== oldFlows) {
        this.visibleFlows = [];
        console.log("watch flows", newFlows);
        newFlows.forEach((id) => {
          const journeyExist = this.flowsOptions.find((item) => item.id == id);
          if (journeyExist && journeyExist.children) {
            const allChildrenExist = journeyExist.children.every((child) =>
              newFlows.includes(child.id)
            );
            if (!allChildrenExist) {
              // Remove journeyExist from newFlows
              newFlows.splice(newFlows.indexOf(id), 1);
            }
          }
          if (this.getFlow(id)) this.visibleFlows.push(id);
        });

        // calculate slidesPerView dynamically based on total width of buttons
        setTimeout(() => {
          const swiperButtonSlides = document.querySelectorAll(
            ".swiper-button-slide"
          );
          let totalWidth = 0;
          swiperButtonSlides.forEach((slide) => {
            totalWidth += slide.offsetWidth;
          });
          if (totalWidth > 0) {
            totalWidth = totalWidth + 16 * this.visibleFlows.length; // add the margins between buttons
            const noOfSlides = Math.ceil(totalWidth) / 405; // 405 is the total width of visible area
            this.slidesPerView = this.visibleFlows.length / noOfSlides;
            console.log(
              "Total width:",
              totalWidth,
              noOfSlides,
              this.slidesPerView
            );
          }
        }, 1000);
        this.updateActiveFlow();
      }
    },
  },
  methods: {
    ...mapActions("users", [
      "checkUniqueSection",
      "getSection",
      "addSection",
      "editSection",
    ]),
    ...mapActions("journey", ["fetchJourneyFlows", "fetchJourneyFlowsDetails"]),
    ...mapActions("visit", ["fetchSitesAndAreasByEntityId"]),

    setSmileysText(scaleCount) {
      let smileyText = [];
      switch (scaleCount) {
        case 3:
          smileyText = [this.$t('customFields.smileys.poor'), this.$t('customFields.smileys.ok'), this.$t('customFields.smileys.good')];
          break;
        case 5:
          smileyText = [this.$t('customFields.smileys.bad'), this.$t('customFields.smileys.poor'), this.$t('customFields.smileys.ok'), this.$t('customFields.smileys.good'), this.$t('customFields.smileys.great')];
          break;
      }
      return smileyText;
    },

    handleClickOutside(event) {
      const containers = document.querySelectorAll(
        ".vue-treeselect__multi-value-item-container"
      );
      containers.forEach((container) => {
        const journeyItem = container.querySelector(".isJourney");

        if (!container.contains(event.target) && journeyItem) {
          container.style.display = "none";
        }
      });
    },
    handleActiveFlow(flow) {
      this.activeFlow = flow;
      this.changeFlowsValues(this.getFlow(flow));
    },

    getFlow(id) {
      let flowExist;
      this.flowsOptions.forEach((journey) => {
        if (journey.children && !flowExist)
          flowExist = journey.children.find((flow) => flow.id == id);
      });
      return flowExist;
    },

    updateActiveFlow() {
      let flowId;
      // find first flow id
      this.flows.forEach((id) => {
        if (!flowId) {
          const journeyExist = this.flowsOptions.find((item) => item.id == id);
          if (!journeyExist) flowId = id;
        }
      });
      if (
        this.activeFlow &&
        !this.flows.some((flow) => flow === this.activeFlow)
      ) {
        console.log("acive flow not found");
        this.changeFlowsValues(this.getFlow(flowId));
      } else if (!this.activeFlow) this.changeFlowsValues(this.getFlow(flowId));
    },

    async changeValues() {
      try {
        this.flowsLoaded = false;
        this.flowsOptions = [];
        if (this.sites.length) {
          const journey = await this.fetchJourneyFlows(this.sites);
          const flowsOptions = journey.data.map((journey) => {
            return {
              id: journey.id,
              label: journey.name,
              name: journey.name,
              isJourney: true,
              children: journey.flows.map((flow) => {
                return {
                  id: flow.id,
                  label: flow.name,
                  name: flow.name,
                  customLabel: `${flow.name} (${journey.name})`,
                  journey_id: flow.journey_id,
                  journey_name: journey.name,
                };
              }),
            };
          });
          this.flowsOptions = flowsOptions.filter(
            (item) => item.children && item.children.length
          );
        }
        this.flowsLoaded = true;
      } catch (error) {
        // console.error("Error fetching journey:", error);
        this.flowsLoaded = true;
      }
    },
    async changeFlowsValues(flow) {
      try {
        if (!flow || !flow.id) {
          console.error("Invalid flow object:", flow);
          return;
        }

        const currentFlowDetails = await this.fetchJourneyFlowsDetails(flow.id);

        // Check if the flow already exists in selectedFlows
        const existingFlowIndex = this.selectedFlows.findIndex(
          (f) => f.id === flow.id
        );
        if (existingFlowIndex === -1) {
          this.selectedFlows.push(flow);
        }
        this.activeFlowJourney = currentFlowDetails.data.journey;
        this.activeFlowUserTypes = currentFlowDetails.data.userTypes;
        this.activeFlowSections = currentFlowDetails.data.sections;

        this.activeFlow = flow.id;
      } catch (error) {
        console.error("Error fetching journey:", error);
      }
    },

    checkSectionName() {
      if (this.isInitializing) {
        return;
      }
      this.formChanged = true;
      this.sectionNameErr = "";
      let obj = {
        value: this.sectionName,
      };
      if (this.$route.query.sectionId)
        obj.section_id = this.$route.query.sectionId;
      this.checkUniqueSection(obj).then((data) => {
        this.sectionNameErr = data;
      });
    },
    getIconName(icon) {
      return icon.split("fa-")[1].includes("-icon")
        ? icon.split("fa-")[1]
        : `${icon.split("fa-")[1]}-icon`;
    },
    fieldTypeChanged(index) {
      if (this.isInitializing) {
        return;
      }
      setTimeout(() => {
        this.formChanged = true;
        if (
          this.customFields[index].type == "checkboxes" ||
          this.customFields[index].type == "longText"
        ) {
          this.customFields[index].isAllowedPrint = false;
          this.customFields[index].icon = "";
        }
        if (this.customFields[index].type == "ratingScale") {
          this.customFields[index].showAs = "labels";
          this.customFields[index].scaleCount = 5;
        }
        if (
          this.customFields[index].type !== "checkboxes" &&
          this.customFields[index].type !== "radioButtons"
        )
          this.customFields[index].options = [
            { name: "", err: false },
            { name: "", err: false },
          ];
      }, 0);
    },
    validateFieldName(index) {
      if (this.isInitializing) {
        return;
      }
      this.formChanged = true;
      const uniqueOptions = Array.from(
        new Set(this.customFields.map((option) => option.name))
      );
      const arr = uniqueOptions.map((name) => ({ name, fieldNameErr: false }));
      if (arr.length == this.customFields.length) {
        this.customFields.map((item) => (item.fieldNameErr = false));
      }
      const fieldName = this.customFields[index].name;
      // Check if fieldName exists across other customFields names
      const exists = this.customFields.some(
        (field, i) =>
          i !== index &&
          field.name.toLowerCase().trim() === fieldName.toLowerCase().trim()
      );
      this.customFields[index].fieldNameErr = exists;
    },
    validateOption(fieldIndex, optionIndex) {
      if (this.isInitializing) {
        return;
      }
      this.formChanged = true;
      const uniqueOptions = this.getUniqueOptions(
        this.customFields[fieldIndex].options
      );
      if (
        uniqueOptions.length == this.customFields[fieldIndex].options.length
      ) {
        this.customFields[fieldIndex].options.map((item) => (item.err = false));
      }
      const option = this.customFields[fieldIndex].options[optionIndex];
      // Check if option exists across other options of the same custom field
      const exists = this.customFields[fieldIndex].options.some(
        (opt, i) =>
          i !== optionIndex &&
          opt &&
          option.name &&
          opt.name.toLowerCase().trim() === option.name.toLowerCase().trim()
      );
      // if (exists) {
      //     this.customFields[fieldIndex].options.map((opt, i) => {
      //         if (i !== optionIndex && opt.name === option.name)
      //         opt.err = false;
      //     });
      // }
      this.customFields[fieldIndex].options[optionIndex].err = exists;
    },
    getUniqueOptions(options) {
      const uniqueOptions = Array.from(
        new Set(options.map((option) => option.name))
      );
      return uniqueOptions.map((name) => ({ name, err: false }));
    },
    addCustomField() {
      this.customFields.push({
        id: null,
        fieldUpdated: false,
        name: "",
        type: null,
        options: [
          { name: "", err: false },
          { name: "", err: false },
        ],
        showAs: "labels",
        scaleCount: 5,
        icon: "",
        isMandatory: true,
        isFillableByUser: true,
        isPreRegFilled: false,
        isAllowedPrint: false,
        showOn: null,
      });
    },
    deleteCustomField(index) {
      this.formChanged = true;
      if (this.customFields[index].id)
        this.deletedCustomFields.push(this.customFields[index].id);
      if (this.isMainSection && this.customFields.length == 1) {
        this.customFields = [];
        this.addCustomField();
      } else this.customFields.splice(index, 1);
    },
    getVisibleSmileys(scaleCount) {
      const smileysToShow = [
        ["sad", "happy"],
        ["sad", "poker", "happy"],
        ["sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy"],
        ["sad", "semi-sad", "poker", "semi-happy", "happy", "smile"],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
        ],
        [
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
        [
          "frown",
          "cry",
          "hesitate",
          "sad",
          "semi-sad",
          "poker",
          "semi-happy",
          "happy",
          "smile",
          "love",
        ],
      ];

      return smileysToShow[scaleCount - 2];
    },
    getSmileySvg(smiley) {
      return smileysJson[smiley];
    },
    addOption(fieldIndex) {
      this.formChanged = true;
      const field = this.customFields[fieldIndex];
      if (field.type === "checkboxes" || field.type === "radioButtons") {
        field.options.push({ name: "" });
      } else if (field.scaleCount < 10) {
        field.scaleCount++;
      }
    },
    removeOption(fieldIndex) {
      this.formChanged = true;
      const field = this.customFields[fieldIndex];
      if (field.scaleCount > 2) {
        field.scaleCount--;
      }
    },
    onSubmit() {
      this.isLoading = true;
      const filledCustomFields = this.customFields.filter(
        (item) => !!item.name && !!item.type
      );
      const customFields = filledCustomFields.map((item) => {
        const obj = {
          id: item.id,
          fieldUpdated: item.fieldUpdated,
          name: item.name,
          type: item.type,
          is_mandatory:
            item.isMandatory && item.type !== "toggleButton" ? 1 : 0,
          is_fillable_by_user: item.isFillableByUser ? 1 : 0,
          is_pre_registration_filled: item.isPreRegFilled ? 1 : 0,
          is_allowed_print: item.isAllowedPrint ? 1 : 0,
          icon: item.isAllowedPrint ? item.icon : "",
          show_type: item.showOn,
        };
        const options = item.options.filter((item) => !!item.name);

        if (item.type == "checkboxes" || item.type == "radioButtons") {
          obj.metadata = [
            {
              options: options.map((option) => {
                return option.name;
              }),
            },
          ];
        } else if (item.type == "ratingScale") {
          obj.metadata = [
            {
              show_as: item.showAs,
              scale_count: item.scaleCount,
            },
          ];
        }
        return obj;
      });
      const form = {
        section: {
          name: this.sectionName,
          type: this.sectionBinding,
        },
        custom_fields: customFields,
      };
      if (this.sectionBinding == 0) form.user_type_ids = this.userTypes;
      if (this.addFlow && this.isAdd) {
        let arr = [];
        this.flows.map((flowId) => {
          if (!this.flowsOptions.find((journey) => journey.id == flowId))
            arr.push(flowId);
        });
        form.journey_flow_ids = arr;
      }
      // console.log("form", form);
      if (this.$route.query.sectionId) {
        const obj2 = {
          section: {
            name: this.sectionName,
          },
        };
        if (this.sectionBinding == 0) obj2.user_type_ids = this.userTypes;
        if (customFields.find((item) => !item.id))
          obj2.new_custom_fields = customFields.filter((item) => !item.id);
        if (customFields.find((item) => item.id && !!item.fieldUpdated)) {
          const arr = customFields.filter(
            (item) => item.id && !!item.fieldUpdated
          );
          obj2.updated_custom_fields = arr;
        }
        if (this.deletedCustomFields.length) {
          obj2.deleted_custom_field_ids = this.deletedCustomFields;
        }
        this.editSection({ id: this.$route.query.sectionId, form: obj2 })
          .then(() => {
            this.isLoading = false;
            this.$router.push({
              path: "/custom-fields",
            });
          })
          .catch(() => {
            // this.sectionNameErr = err.data.message;
            // this.addFlow = false;
            this.isLoading = false;
          });
      } else {
        this.addSection(form)
          .then(() => {
            this.isLoading = false;
            this.$router.push({
              path: "/custom-fields",
            });
          })
          .catch(() => {
            // this.sectionNameErr = err.data.message;
            // this.addFlow = false;
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
<style lang="scss">
.vue-treeselect__single-value{
  line-height: 30px;
}
.smiley-text {
  font-weight: 900;
  font-size: 9px;
  line-height: 17px;
  // leading-trim: both;
  // text-edge: cap;
  text-align: center;
  letter-spacing: 0.25px;
  color: #787878;
}
.show-item {
  opacity: 1 !important;
}
.prereg-check {
  opacity: 0;
  gap: 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.25px;
  text-align: start;
  color: #787878;
  margin-inline-start: 20px;
  custom-control-input {
    width: 17px !important;
    height: 17px !important;
  }
  .custom-checkbox {
    margin-top: 27px;
  }
  .custom-checkbox .custom-control-label::after {
    width: 23px !important;
    height: 23px !important;
    top: -1px !important;
    inset-inline-start: -26.5px !important;
  }
}
.VueCarousel {
  width: 100% !important;
}
.VueCarousel-slide {
  flex-basis: auto !important;
}
.swiper-button {
  margin-inline-end: 16px;
}
.VueCarousel-pagination {
  display: none !important;
}
.user-type-con.d-flex.flex-wrap {
  gap: 8px;
}
.journey-con.d-flex {
  max-width: 405px;
  overflow-x: hidden;
}
.emty-input {
  width: 286px;
  background-color: #f2f2f2;
  padding-inline-start: 20px;
  height: 55px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;

  line-height: 17px;
  color: #787878;
}
.second-input-text {
  font-weight: 700;
  color: #4a4a4a !important;
  font-size: 16px !important;
  line-height: 17px;
}
.second-input-con {
  color: #103f5e;
  font-weight: 700;
  font-size: 12px;
  line-height: 17px;
  background: #f2f2f2;
  padding-top: 9px;
  width: 251px;
  padding-inline-start: 20px;
  border-end-start-radius: 4px;
  border-start-start-radius: 4px;
}
button.enabled-remove-icon {
  border: none;
  background: none;
  cursor: pointer !important;
  padding: 0px !important;
}
button.closed-icon {
  cursor: not-allowed !important;
  border: none;
  opacity: 0.4 !important;
  background: none;
  padding: 0px !important;
}
.all-section-applied {
  min-height: 75vh;
  position: relative;
  .section-applied-on {
    background: #ffffff;
    padding: 32px;
    border-radius: 8px;

    .journey {
      margin-inline-start: 24px;
      background: #f2f2f2;
      width: 437px;
      padding: 16px;
      border-radius: 4px;
      .box-one {
        // margin-inline-end: 8px;
        //margin-bottom: 8px !important;
        white-space: nowrap;
        overflow: hidden;
        border-radius: 4px;
        text-overflow: ellipsis;
        max-width: 351px;
        .box-text {
          padding-inline-start: 6px;
          padding-inline-end: 6px;
          height: 23px;
          white-space: nowrap;
          overflow: hidden;
          border-radius: 4px;
          text-overflow: ellipsis;
          max-width: 351px;
          font-weight: 500;
          font-size: 16px;
          border-radius: 3px;
          background: #f2f2f2;
          color: #4a4a4a;
          line-height: 24px;
        }
      }
      .journey-one {
        .box-text-one {
          font-weight: 500;
          font-size: 16px;

          color: #4a4a4a;
        }
      }
      p.custom-btn {
        margin-bottom: 0px !important;
        line-height: 24px;
        margin-top: -1px;
        border: none;
        padding-inline-end: 16px;
        padding-inline-start: 16px;
        height: 23px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer !important;
        border-radius: 18.5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 342px;
      }
      button.active-btn {
        border: none;
        padding: 0px !important;
        height: 23px;

        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        // margin-inline-end: 16px;
        border-radius: 18.5px;

        cursor: pointer !important;

        background: #103f5e;
      }
      button.notSelected-btn {
        border: none;
        padding: 0px !important;
        height: 23px;
        // margin-inline-end: 16px;
        //line-height: 24px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer !important;
        border-radius: 18.5px;

        background: #c7c7c7;
      }
      div#white-con {
        border-radius: 8px;
        width: 405px;
        background: #ffffff;
        padding: 16px;
        height: 251px;
        margin-top: 16px;
        ::-webkit-scrollbar {
          width: 9px !important;
          height: 30px !important;
        }

        ::-webkit-scrollbar-track {
          background: #c7c7c7 !important;
          margin-inline-start: 31px !important;
          height: 219px !important;
          border-radius: 8.5px !important;
          -webkit-box-shadow: #ffff !important;
          margin-top: 16px !important;
          margin-bottom: 16px !important;
        }

        ::-webkit-scrollbar-thumb {
          background: #666666 !important;
          border-radius: 8.5px !important;
        }
        .white-box {
          width: 372px;
          background: #ffffff;
          overflow-y: auto;
          height: 232px;

          p.journey-title {
            color: #103f5e;
            font-weight: 700;
            font-size: 12px;
            line-height: 14px;
            margin-bottom: 16px;
          }
          p.user-type-title,
          p.section-title {
            color: #103f5e;
            font-weight: 700;
            font-size: 12px;
            line-height: 14px;
            margin-bottom: 16px;
          }
          p.no-assigned-sections {
            color: #4a4a4a;
            font-size: 16px;

            margin-bottom: 0px !important;

            font-weight: 500;
          }
          p.journey-name {
            color: #4a4a4a;
            font-size: 16px;
            line-height: 24px;

            font-weight: 500;
          }
        }
      }
    }
    p.applied-text {
      color: #787878;
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 32px;
      font-weight: 700;
    }
    .site-dropdown {
      margin-bottom: 16px;
    }
    .flow-dropdown {
      span.vue-treeselect__multi-value-label > div {
        padding: 0px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 298px !important;
      }
    }
  }
  .site-dropdown {
    span.vue-treeselect__multi-value-label > div {
      padding: 0px !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 298px !important;
    }
  }
  button.out-back-btn {
    border: none;
    margin-inline-end: 24px;
    cursor: pointer !important;
    padding: 0px;
    &:disabled {
      opacity: 0.4 !important;
      cursor: not-allowed !important;
    }
  }
}

li.breadcrumb-item a {
  color: #4a4a4a !important;
}

.parking-con {
  background: #f2f2f2;
  display: flex;
  align-items: center;
  padding-inline-end: 17px;
  border-start-end-radius: 4px;
  border-end-end-radius: 4px;
  margin-inline-start: -3px !important;
}

div#iconsModal___BV_modal_content_ {
  border-radius: 26px !important;
  width: 500px !important;

  div#iconsModal___BV_modal_body_ {
    padding: 0px 0px 40px 0px !important;

    ::-webkit-scrollbar {
      width: 9px;
      height: 30px !important;
    }

    ::-webkit-scrollbar-track {
      background: #c7c7c7;
      padding-top: 30px !important;
      border-radius: 8.5px;
      -webkit-box-shadow: #ffff;
      margin-top: 21px !important;
      margin-bottom: 13px !important;
    }

    ::-webkit-scrollbar-thumb {
      background: #666666;
      border-radius: 8.5px;
      height: 358px !important;
    }
  }

  .submit-con {
    width: 416px;
    margin-inline-end: auto;
    margin-inline-start: auto;

    button.btn.btn-primary.save-feedback {
      width: 416px !important;
      cursor: pointer !important;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;

      font-weight: 700;
      line-height: 17px;

      &:disabled {
        cursor: not-allowed !important;
        opacity: 0.4;
      }
    }
  }

  form.search-bar {
    width: 416px;
    height: 55px;
    background: #f2f2f2;
    display: flex;
    border-radius: 4px;
    align-items: center;
    margin-inline-end: auto;
    padding-inline-start: 20px;
    margin-inline-start: auto;
    margin-bottom: 40px;
  }

  .d-flex.align-items-center.justify-content-end.modal-title-head {
    margin-top: 40px;
    margin-bottom: 40px;
    margin-inline-end: auto;
    width: 416px;
    margin-inline-start: auto;

    p.feedback-title-head {
      font-size: 16px;

      font-weight: 700;
      line-height: 20.4px;
      color: #000000;
      margin-inline-end: 156px;
      margin-bottom: 0px !important;
    }

    .CloseFeedbackSettings {
      margin-inline-end: -8px;
      margin-top: -8px;
    }
  }

  button.search-btn {
    border: none;
    cursor: pointer !important;
    margin-inline-start: 0px;
    padding-inline-start: 0px;
    padding-inline-end: 0px;
    margin-inline-end: 16px;
  }

  input.search-input:focus {
    outline: none !important;
    width: 100%;
    background: #f2f2f2 !important;
  }

  input.search-input {
    border: none;
    background: #f2f2f2;
    height: 55px;
    color: #4a4a4a;
    font-size: 16px;
    font-weight: 700;
    line-height: 17px;

    &::placeholder {
      color: #787878 !important;
      font-size: 16px;
      font-weight: 400;
      line-height: 17px;
    }
  }

  i.unique-icon {
    color: #787878;
    // margin-inline-start: 27px !important;
    // margin-top: 27px !important;
    // margin-inline-end: 27px !important;
    // margin-bottom: 27px !important;
  }

  i.unique-icon::before {
    width: 24px !important;
    height: 24px !important;
    background: #ffffff !important;
    border-radius: 4px;

    padding: 6px;
  }
  .unique-icon.fa-lg.icon-selected {
    color: #103f5e !important;
  }
  .unique-icon.fa-lg.icon-selected::before {
    background: #e9f2fd !important;
    border-radius: 4px;

    padding: 6px;
  }

  .d-flex.flex-wrap.modal-icons {
    width: 414px;
    height: 420px;
    margin-bottom: 40px;
    // justify-content: space-between;
    overflow-y: auto;
    overflow-x: hidden;

    margin-inline-start: 10%;
  }
}

.add-field-con {
  padding-bottom: 32px;
  margin-inline-start: 32px;
}

.bottom-border {
  background: #ebebeb;
  height: 2px;
}

.remove-section {
  margin-top: 32px;
}

button.add-field-btn {
  width: 99px;
  height: 30px;
  align-items: center;
  justify-content: center;
  cursor: pointer !important;
  display: flex;
  font-size: 16px;
  color: #ffffff;
  line-height: 19px;
  font-weight: 400;
  border-radius: 55px;
  background: #2680eb;
  border: none;
}

button.add-field-btn:disabled {
  opacity: 1 !important;
  background-color: #a8ccf7;
  cursor: not-allowed !important;
}

.sections-con.d-flex.justify-content-between {
  width: 100%;
}

.add-circle {
  width: 48px;
  height: 48px;
  background: #2680eb;
  cursor: pointer !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 100%;
  &:disabled {
    opacity: 1 !important;
    background-color: #a8ccf7;
    cursor: not-allowed !important;
  }
}

.show-on-con {
  margin-top: 32px;
  margin-inline-start: 20px;
  p.show-as {
    color: #787878;
    font-size: 16px;
    font-weight: 600;
    line-height: 17px;

    margin-bottom: 32px;
  }

  span.label-label {
    width: 30px;
    height: 30px;
    border: solid #787878 1.5px;
    font-size: 16px;
    line-height: 19px;
    font-weight: 600;
    color: #787878;
    margin-inline-end: 8px;
    border-radius: 100px;
  }

  .custom-control-inline {
    margin-inline-end: 32px !important;
  }
}

.rating-con {
  margin-top: 32px;
  margin-inline-start: 20px;

  p.show-as {
    color: #787878;

    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
    margin-bottom: 32px;
  }

  span.label-label {
    width: 30px;
    height: 30px;
    border: solid #787878 1.5px;
    font-size: 16px;
    line-height: 19px;
    font-weight: 600;
    color: #787878;
    margin-inline-end: 8px;
    border-radius: 100px;
  }

  .custom-control-inline {
    margin-inline-end: 32px !important;
  }
}

.sections-remove-con {
  padding: 32px;
}

.all-fields-add {
  background: #ffffff;

  border-radius: 8px;
}
.selctions-note {
  width: 376px;
  margin-top: 8px;

  font-size: 14px;
  line-height: 21px;
  margin-inline-start: 20px;

  font-weight: 400;
  color: #787878;
}

.sep-items-line {
  position: absolute;
  width: 2px;
  background: #ebebeb;
  height: 339px;
  inset-inline-start: -135px;
}

.field-name-section {
  background: #ffffff;
  padding: 32px;
  border-radius: 8px;
  margin-bottom: 24px;

  .name-con {
    margin-bottom: 32px;
    .section-note {
      width: 376px;
      margin-top: 8px;

      font-size: 14px;
      line-height: 21px;
      margin-inline-start: 20px;

      font-weight: 400;
      color: #787878;
    }
  }

  .section-binded {
    margin-inline-start: 20px;
    margin-bottom: 32px;

    p.header-binded {
      margin-bottom: 32px !important;
      font-size: 16px;
      font-weight: 700;
      line-height: 19px;
      color: #787878;
    }
  }
}

.all-fields-type-con {
  div#field-name {
    margin-bottom: 16px !important;
  }

  .right-section {
    position: relative;
    button.select-btn {
      border: none;
      border-radius: 4px;
      background: #103f5e;
      width: 115px;
      cursor: pointer !important;
      height: 55px;
      font-size: 16px;
      color: #ffffff;

      justify-content: center;
      align-items: center;
      display: flex;
      font-weight: 700;
      line-height: 17px;
      margin-inline-start: 15px;
    }

    .mandatory,
    .filled-by,
    .padge {
      width: 416px;
      border-radius: 4px;
      background: #f2f2f2;
      height: 55px;
      margin-bottom: 16px;
      padding-inline-end: 20px;
      padding-inline-start: 20px;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
    }

    p.mandatory,
    p.filled-by,
    p.padge {
      margin-bottom: 0 !important;
      color: var(--Grey-1, #787878);

      display: contents;
      font-size: 16px;

      font-weight: 700;
      line-height: normal;
    }

    .switch-gray .custom-control-label::before {
      top: 6px !important;
      width: 43px !important;
      height: 21px !important;
      background: #d1d1d1 !important;
      border: none !important;
      border-radius: 13.5px;
    }

    .switch-gray.radio-updateArea .custom-control-label::after {
      top: 6px !important;
      // inset-inline-start: -45px !important;
      background: #939393;
      width: 21px !important;
      height: 21px !important;
      border-radius: 100% !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }

    .switch-gray.radio-updateArea
      .custom-control-input:checked
      ~ .custom-control-label:before {
      position: absolute;
      top: 6px !important;
    }

    .switch-gray .custom-control-input:checked ~ .custom-control-label:before {
      position: absolute;
      top: 0px !important;
      width: 43px;
      height: 21px;
      background: #d1d1d1 !important;
      border: none !important;
      border-radius: 13.5px !important;
    }

    .switch-gray.radio-updateArea.custom-control.custom-switch.b-custom-control-lg {
      margin-top: -13px;
      margin-inline-end: -7px;

      .custom-control-input:checked ~ .custom-control-label:after {
        width: 21px !important;
        height: 21px !important;
        top: 6px !important;
        background-color: #34c38f;
      }
    }
  }
}
</style>
